import React from 'react';
import { Input } from '../common/Input';
import { Select } from '../common/Select';
import { Button } from '../common/Button';
import { Search, X } from 'lucide-react';

export const FilterBar = ({ filters, onFilterChange, disabled }) => {
    return (
        <div className="flex flex-col sm:flex-row gap-4 items-center">
            <div className="relative w-full sm:w-96">
                <input
                    type="text"
                    placeholder="Search subscriptions..."
                    value={filters.search}
                    onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
                    disabled={disabled}
                    className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                />
            </div>
            <select
                value={filters.sortBy}
                onChange={(e) => onFilterChange({ ...filters, sortBy: e.target.value })}
                disabled={disabled}
                className="w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            >
                <option value="date-asc">Soonest Due</option>
                <option value="date-desc">Furthest Due</option>
            </select>
        </div>
    );
}; 